









import { computed, defineComponent } from 'vue-demi';
import { windowHelper } from '@tencent/ppd-base-libs';
import Info from './info.vue';
import List from './list/index.vue';
import { useMall } from '../hooks/use-mall';

export default defineComponent({
  name: 'MallContent',
  components: {
    Info,
    List,
  },
  emits: ['beforeCompleted', 'afterCompleted', 'couponBtnClick'],
  setup(props, context) {
    const { currMallInfo } = useMall();
    const isHasData = computed(() => !!currMallInfo.value);

    const mallInfo = computed(() => {
      const { id, name, desc, addr } = currMallInfo.value || {};
      return { id, name, desc, addr };
    });

    const spid = computed(() => mallInfo.value.id || '');

    const bgStyle = computed(() => {
      const { value } = currMallInfo;
      if (!value) return {};

      const { bgImgUrl, bgColor } = value;
      return {
        backgroundImage: `url(${bgImgUrl})`,
        backgroundColor: bgColor,
      };
    });

    function handleAfterCompleted(id: string) {
      context.emit('afterCompleted', id);
    }

    function handleGoSpChannel() {
      const url = `//prom.wechatpay.com.hk/merchant-channel/index.shtml?ADTAG=mall&spId=${encodeURIComponent(mallInfo.value.id || '')}`;
      windowHelper.redirect(url);
    }

    return {
      spid,
      isHasData,
      mallInfo,
      bgStyle,
      handleGoSpChannel,
      handleAfterCompleted,
    };
  },
});
